import React, {FC} from 'react';
import Select from 'react-select';
import {useTranslation} from 'gatsby-plugin-react-i18next';

import {SupportedRegions} from '../../../types/lang';

// module.scss files compile class names to be unique
// since class names are handled by react-select, we need to use a regular scss file
// so that the classes in the scss file are not modified
import './selectArea.scss';


type Props = {
  selectedArea: SupportedRegions | null,
  setSelectedArea: (selectedArea: Props['selectedArea']) => void,
};

type Option = {
  value: SupportedRegions | '',
  label: string,
};


const SelectArea: FC<Props> = ({selectedArea, setSelectedArea}) => {
  const {t} = useTranslation();

  const options: Option[] = [
    {value: '', label: t('country.no_country_choosen')},
    {value: SupportedRegions.EU, label: t('country.europe')},
    {value: SupportedRegions.NA, label: t('country.north_america')},
    {value: SupportedRegions.CSA, label: t('country.centre_south_america')},
    {value: SupportedRegions.MEA, label: t('country.middle_east_africa')},
    {value: SupportedRegions.SEA, label: t('country.south_east_asia')},
    {value: SupportedRegions.CH, label: t('country.china')},
    {value: SupportedRegions.IN, label: t('country.india')},
    {value: SupportedRegions.OC, label: t('country.oceania')},
  ];

  return (
    <div className="selectArea">
      <label htmlFor="area-usage">{t('area-usage')}</label>
      <Select
        options={options}
        menuPlacement="auto"
        classNamePrefix="react-select"
        className="react-select-container"
        placeholder={t('country.no_country_choosen')}
        onChange={(area) => setSelectedArea(area?.value || null)}
        value={options.filter((item) => item.value === selectedArea)}
      />
    </div>
  );
};


export default SelectArea;
